"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterval = void 0;
// @ts-nocheck
const react_1 = require("react");
function useInterval(callback, delay, canStart) {
    const savedCallback = (0, react_1.useRef)(null);
    // Remember the latest callback.
    (0, react_1.useEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    (0, react_1.useEffect)(() => {
        function tick() {
            if (savedCallback.current) {
                savedCallback.current();
            }
        }
        if (delay !== null && canStart) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay, canStart]);
}
exports.useInterval = useInterval;
//# sourceMappingURL=useInterval.js.map